<template>
  <div class="header">
    <div class="logo">
      <img :src="logo" class="logo" alt="" />
    </div>
    <div class="account">
      <el-dropdown trigger="click">
        <span class="el-dropdown-link"> <img :src="userImg" alt="" class="user"/> <i class="el-icon-caret-bottom mark"/></span>

        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item icon="el-icon-s-custom" @click.native="personalManage">个人中心</el-dropdown-item>
          <el-dropdown-item icon="el-icon-switch-button" @click.native="logout">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userinfo: {},
      logo: require("../assets/images/logo.png"),
      userImg: ""
    }
  },
  methods: {
    logout1() {
      this.$store.commit("clearToken")
      this.$store.commit("clearMenu")
      //this.$router.push({ path: "/login" })
      location.reload()
    },
    logout() {
      this.$store.dispatch("Logout").then(res => {
        if (res.code === 20000) {
          location.reload()
        }
      })
    },
    personalManage() {
      this.$router.push({ path: "/person/index" })
    }
  },
  created() {
    this.userinfo = JSON.parse(localStorage.getItem("user_info"))
    this.userImg = this.userinfo["avatar"]
    console.log("头像", this.userinfo["avatar"])
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  // height: 100%;
  padding: 10px 0;
  position: relative;
  // background: #fff;
  align-items: center;
  justify-content: space-between;
  .logo {
    height: 40px;
  }
  .account {
    // border: 1px solid green;
    display: flex;
    align-items: center;
    img {
      width: 42px;
      height: 42px;
      border-radius: 50%;
      cursor: pointer;
    }
    .mark {
      font-size: 15px;
      color: #5a5e66;
      margin-left: 2px;
      cursor: pointer;
      &:hover {
        color: #2486e4;
      }
    }
  }
}
</style>
